var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row", attrs: { id: "index-app" } }, [
      _c("div", { staticClass: "homepage-content" }, [
        _c(
          "div",
          { staticClass: "titles d-flex flex-column text-center py-3" },
          [
            _c(
              "a",
              {
                staticClass: "text-decoration-none",
                attrs: { href: "analysis.html" }
              },
              [
                _c("h1", { staticClass: "text-body font-weight-bold" }, [
                  _vm._v("TESAS")
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "text-body font-weight-bold" }, [
                  _vm._v("Taiwan Economic Society Analysis System")
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "text-body font-weight-bold" }, [
                  _vm._v("地方創生資料庫")
                ]),
                _vm._v(" "),
                _c(
                  "h6",
                  { staticClass: "small text-black-50 font-weight-bold px-3" },
                  [
                    _vm._v(
                      "為創造更友善的使用環境及體驗，地方創生資料庫（TESAS）歡迎各界反饋使用經驗，以作為修正改進之參考。"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "h6",
              { staticClass: "small text-black-50 font-weight-bold px-3" },
              [
                _vm._v(
                  "\n        本網站為促進資料之共用，亦同時以 API 介接方式提供資料介接，並以 Swagger UI 提供介接案例以協助介接參數等內容之理解。詳見 "
                ),
                _c(
                  "a",
                  { attrs: { href: "../tesas_api/swagger/index.html" } },
                  [_vm._v("TESAS Swagger")]
                ),
                _vm._v(" 網頁及"),
                _c(
                  "a",
                  { attrs: { href: "docs/TESAS-API_簡易使用說明.pdf" } },
                  [_vm._v("說明文件")]
                ),
                _vm._v("。\n      ")
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }